import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on the "Help" button on the header menu
 * Event: dental_portal:menu_bar:help_clicked
 */
export function fireMenuBarHelpClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:help_clicked');
}
